import { ConfirmationModal as SuiConfirmationModal } from '@hrworks/sui-core/ConfirmationModal'

interface SessionExpiredModalProps {
  onConfirm: () => void
}

export const SessionExpiredModal = ({ onConfirm }: SessionExpiredModalProps) => (
  <SuiConfirmationModal
    show
    title="Session expired"
    confirmText="Sign in again"
    onConfirm={onConfirm}
    closeOnBackdropClick={false}
  >
    Your session has expired. Please sign in again to continue.
  </SuiConfirmationModal>
)
